import { useEffect, useState } from "react";

export function useIncrementMeta(value, storageKey) {
  const [meta, setMeta] = useState({ increment: "+0.00%", type: "positive" });

  useEffect(() => {
    const current = parseFloat(value) || 0;
    const previous = parseFloat(localStorage.getItem(storageKey) || "0") || 0;

    const diff = current - previous;
    const percentage =
      previous > 0 ? ((diff / previous) * 100).toFixed(2) : "0.00";

    setMeta({
      increment: (diff >= 0 ? "+" : "") + percentage + "%",
      type: diff >= 0 ? "positive" : "negative",
    });

    localStorage.setItem(storageKey, current.toString());
  }, [value, storageKey]);

  return meta;
}
